export const AirportsFrom = 'airports-from';
export const AirportsTo = 'airports-to';
export const Carrier = 'carrier';
export const Stops = 'stops';
export const IsActive = 'is-active';
export const IsOperating = 'is-operating';
